<template>
  <div class="message-container">
    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
    <!-- 表单 -->
    <ots-refer
      :selectList="selectList"
      :request-form="selectForm"
      @search="getResult"
    />
    <!-- 表格 -->
    <ots-table-group-new
      :tableHeader="tableHeader"
      :tableOption="tableOption"
      :tableData="tableData"
      :batchOperBtn="batchOperBtn"
      :pagination="pagination"
      @changeNum="changeSize"
      @changePage="changePage"
      @handleSelectionChange="bachOper"
    ></ots-table-group-new>
    <!-- 弹窗 -->
    <ots-custom-dialog
      :dialog.sync="sendDialog"
      title="短信督导"
      width="40%"
    >
      <template v-slot:content>
        <div class="export-setting">
          <ul>
            <li>本次将为<span class="col_red">{{tmpGroupCount.shouldSendCount}}</span>位学生发送督导</li>
            <li>实际可发送<span class="col_red">{{tmpGroupCount.actualSendCount}}</span>条</li>
            <li>只能发送短信督导<span class="col_red">{{tmpGroupCount.onlySendSmsCount}}</span>条</li>
            <li>只能发送邮件督导<span class="col_red">{{tmpGroupCount.onlySendEmailCount}}</span>条</li>
            <li>可同时发送<span class="col_red">{{tmpGroupCount.bothSendCount}}</span>条</li>
          </ul>
          <div class="mt10">
            <el-input type="textarea" v-model="content" :rows="4"/>
          </div>
          <div class="mt20 col_grayQ">
            <p>提示：</p>
            <p class="mt10"> 1、<span class="col_red mr5">{学生姓名}</span>系统动态获取学生的姓名显示！不需要可删除。</p>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="sendDialog = false">取消</el-button>
        <el-button round type="primary" @click="messagePushFn">确定</el-button>
      </template>
    </ots-custom-dialog>
    <!-- 新弹窗 -->
    <ots-custom-dialog
      :dialog.sync="askDialog"
      title="是否参加考试确认"
      width="50%"
    >
      <template v-slot:content>
        <div class="export-setting">
          <ul>
            <li>本次将为<span class="col_red">{{tmpGroupCount.shouldSendCount}}</span>位学生发送督导</li>
            <li>实际可发送<span class="col_red">{{tmpGroupCount.actualSendCount}}</span>条</li>
            <li>只能发送短信督导<span class="col_red">{{tmpGroupCount.onlySendSmsCount}}</span>条</li>
            <li>只能发送邮件督导<span class="col_red">{{tmpGroupCount.onlySendEmailCount}}</span>条</li>
            <li>可同时发送<span class="col_red">{{tmpGroupCount.bothSendCount}}</span>条</li>
          </ul>
          <div class="mt10">
            <el-input type="textarea" v-model="askContent" :rows="4"/>
          </div>
          <div class="mt20 col_grayQ">
            <p>提示：</p>
            <p class="mt10"> 1、<span class="col_red mr5">{学生姓名}</span>、<span class="col_red mr5">{批次名称}</span>、<span class="col_red mr5">{确认考试的链接}</span>由系统动态获取，不需要可删除。</p>
            <p class="mt10"> 2、可对督导文字内容进行编辑修改。</p>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="askDialog = false">取消</el-button>
        <el-button round type="primary" @click="askPushFn">确定</el-button>
      </template>
    </ots-custom-dialog>
  </div>
</template>

<script>
import { getSelectCourse } from '@/http/modules/baseSet/course'
import { getPlaceInfofn } from "@/http/modules/baseSet/majorCourse";
import { getMessageList, sentMessageFn, getMessageSendGroupCountFn } from '@/http/modules/applySet/message'
import { getSinglePlan } from '@/http/modules/examSet/examBatch'

export default {
  name: 'messagePush',
  data () {
    return {
      sendDialog: false,
      askDialog: false,
      mainTopBtnList: [],
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id", 
          data: [],
        },
        {
          title: "考点",
          type: "select",
          requestKey: "placeId",
          label: "placeName",
          value: "placeId",
        },
        {
          title: "审核状态",
          type: "select",
          requestKey: "multiple_state",
          label: "key",
          value: "value",
          multiple: true,
          data: [],
        },
        {
          title: "缴费状态",
          type: "select",
          requestKey: "multiple_payState",
          label: "key",
          value: "value",
          multiple: true,
          data: [
            { key: "全部", value: "" },
            { key: "已缴费", value: "1" },
            { key: "未缴费", value: "0" },
            { key: "退费", value: "2"}
          ],
        },
        {
          title: "报考课程",
          type: "select",
          requestKey: "courseId",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" }
          ],
        },
        {
          title: '教学点',
          type: 'select',
          isSearch: true,
          requestKey: "stationId",
          label: "name",
          multiple: true,
          value: "id",
          data: [
            { id: "", name: "全部" },
          ],
        },
        {
          title: "关键词",
          type: "input",
          requestKey: "searchKey",
          placeholder: "姓名/证件号"
        },
        {
          title: "手机号",
          type: "input",
          requestKey: "phone",
          placeholder: "请输入",
        },
        {
          title: "邮箱",
          type: "input",
          requestKey: "email",
          placeholder: "请输入",
        },
        {
          title: "成绩",
          type: "select",
          requestKey: "scoreState",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            { id: 1, name: "合格" },
            { id: 2, name: "不合格" },
          ],
        },
        {
          title: "模拟考试交卷状态",
          type: "select",
          requestKey: "simulateState",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            { id: 1, name: "已交卷" },
            { id: 2, name: "未交卷" },
          ]
        },
        {
          title: "下载准考证状态",
          type: "select",
          requestKey: "downloadEntranceState",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            { id: 1, name: "已下载" },
            { id: 2, name: "未下载" },
          ]
        },
   
      ],
      selectForm: {
        multiple_payState: [''],
        multiple_state: [''],
        state: '',
        placeId:'',
        payState: '',
        planId: null,
        courseId: '',
        stationId: [''],
        searchKey:'',
        orders: "",
        scoreState: '',
        simulateState: '',
        downloadEntranceState: '',
        page: 1,
        size: 10,
      },
      tempSelecForm: {
        placeId:'',
        state: '1',
        payState: '0',
        planId: null,
        courseId: '',
        stationId:[''],
        realName: "",
        orders: "",
        cardNo: "",
      },
      content: `{学生姓名}您好，`,
      askContent: `{学生姓名}您好，您已成功报名{批次名称}考试，为方便给您进行排考安排，请点击{确认考试的链接}确认是否参加考试：`,
      tableHeader: [
        {
          title: '考试批次',
          prop: 'planName'
        },
        {
          title: '考点',
          prop: 'placeName'
        },
        {
          title: '教学点',
          prop: 'stationName'
        },
        {
          title: "姓名",
          prop: "realName",
        },
        {
          title: "证件号",
          prop: "cardNo",
        },
        {
          title: "手机号",
          prop: "phone",
        },
        {
          title: "邮箱",
          prop: "email",
        },
        {
          title: "报考课程",
          prop: "courseName",
        },
        {
          title: "成绩",
          prop: "score",
        },
        {
          title: "审核状态",
          prop: "auditState",
        },
        {
          title: "审核不通过原因",
          prop: "reason",
        },
        {
          title: "缴费状态",
          prop: "payState",
          type: 'tag_Z',
          tagColor: (scope) => {
            const options = {
              '已缴费': 'col_green',
              '未缴费': 'col_grayQ'
            }
            return options[scope.row.payState]
          },
        },
        {
          title: "下载准考证状态",
          prop: "downloadEntranceState",
          fixed: "right"
        },
        {
          title: '模拟考试交卷时间',
          prop: 'simulateTime',
          fixed: "right"
        },
        {
          title: '模拟考试交卷状态',
          prop: 'simulateState',
          fixed: "right"
        }
      ],
      tableOption: {
        multiple: true,
      },
      multipleSelectList: [],
      tableData: [],
      batchOperBtn: [
        {
          title: "短信督导",
          icon: "iconfont icon-duanxindudao",
          click: this.openMessageDialog
        },
        {
          title: "是否参加考试确认",
          icon: "iconfont icon-duanxindudao",
          click: this.openAskDialog
        },
      ],
      pagination: {
        total: 0,
      },
      tmpGroupCount: {},
    }
  },
  computed: {
    studentNum () {
      if (this.multipleSelectList.length) {
        return this.multipleSelectList.length
      }
      return this.pagination.total
    }
  },
  watch: {
    'selectForm.multiple_state': {
      handler (val) {
        this.selectForm.state = val.join()
      },
      immediate: true
    },
    'selectForm.multiple_payState':{
      handler (val) {
        this.selectForm.payState = val.join()
      },
      immediate: true
    },
    'selectForm.planId': {
      handler (val) {
        this.getCurrentSelect()
        this.getResult();
        this.selectForm.multiple_state = [''];
        this.selectForm.placeId = '';
      }
    },
    
  },
  mounted() {
    this.initData();
    this.getCurrentSelect()
  },
  methods: {
    getResult() {
      this.selectForm.page = 1
      this.getTableList();
    },

    openMessageDialog() {
      if(this.multipleSelectList.length == 0) {
        this.$message.warning('请选择学生范围发送短信。')
        return
      }else{
        this.getGroupCount();
        this.sendDialog = true
      }
      return false;
      //下面是以前的代码
      if (this.studentNum) {
        this.sendDialog = true
      } else {
        this.$message.warning('请选择学生范围发送短信。')
      }
    },

    openAskDialog() {
      if(this.multipleSelectList.length == 0) {
        this.$message.warning('请选择学生范围发送短信。')
        return
      }else{
        this.getGroupCount();
        this.askDialog = true
      }
      return false;
      //下面是以前的代码
      if (this.studentNum) {
        this.askDialog = true
      } else {
        this.$message.warning('请选择学生范围发送短信。')
      }
    },
    initData() {
      this.mixin_getSelectPlan().then((data) => {
        if (data) {
          this.$set(this.selectList[0], "data", data);
          this.selectForm.planId = data[0].id;
        }
      });
      this.mixin_getSelectStation().then((data) => {
        let newStationList = [
          {
            id: "",
            name: "全部",
          },
          ...data
        ]
        this.$set(this.selectList[5], 'data', newStationList)
      });
      getSelectCourse().then(res=>{
        let courseList = [
          {
            id: "",
            name: "全部",
          },
          ...res.data
        ]
        this.$set(this.selectList[4], 'data', courseList)
      })

     
    },
   
    dealParamsWithArray(obj) {
      let params = { ...obj }
      for (let item in params) {
        if (Array.isArray(params[item])){
          delete params[item]
        }
      }
      return params
    },
    /******************************
     * @this 获取table表格数据
     ******************************/
     getCurrentSelect(){
      getPlaceInfofn({planIds : this.selectForm.planId}).then(res=>{
        let courseList = [
          {
            placeId: "",
            placeName: "全部",
          },
          ...res.data
        ]
        this.$set(this.selectList[1], 'data', courseList)
       
       })
     },
   
    getTableList() {
        getSinglePlan({planId : this.selectForm.planId}).then(res=>{
          if(res.data.needAudit == 1) {
            let dataList = [
              { value: "", key: "全部" },
              { value: "3", key: "待终审" },
              { value: "4", key: "终审通过" },
              { value: "5", key: "终审不通过" }
            ];
            this.$set(this.selectList[2], 'data', dataList)
          } else if(res.data.needAudit == 2){
            let dataList = [
              { value: "", key: "全部" },
              { value: "1", key: "待初审" },
              { value: "2", key: "初审不通过" },
              { value: "3", key: "待终审" },
              { value: "4", key: "终审通过" },
              { value: "5", key: "终审不通过" }
            ];
            this.$set(this.selectList[2], 'data', dataList)
          } else {
            let dataList = [
              { value : "", key: "全部" },
              { value: "4", key: "审核通过" },
              { value: "6", key: "审核不通过" }
            ];
            this.$set(this.selectList[2], 'data', dataList)
          }

          let params = { ...this.selectForm }
          params.state = params.multiple_state.join()

          if (typeof(this.selectForm.stationId) == 'object') {
            params.stationId = this.selectForm.stationId.join(',')
          }
          for (let item in params) {
            if (Array.isArray(params[item])){
              delete params[item]
            }
          }
          return getMessageList(params)
        }).then( ({data}) => {
          this.tableData = data.records
          this.pagination.total = data.total
          this.tempSelecForm = this.dealParamsWithArray(this.selectForm)
        })
    },

    async getGroupCount(){
      let params = { ...this.selectForm }
      params.state = params.multiple_state.join()

      if (typeof(this.selectForm.stationId) == 'object') {
        params.stationId = this.selectForm.stationId.join(',')
      }
      for (let item in params) {
        if (Array.isArray(params[item])){
          delete params[item]
        }
      }
      params.ids = this.multipleSelectList.join();
      const {code,data} = await getMessageSendGroupCountFn(params);
      if (code == 1) {
        this.tmpGroupCount = data;
      }
    },

    messagePushFn() {
      if (!this.pagination.total) {
        return
      }
      if (!this.content) {
        this.$message.warning('请填写短信内容')
        return
      }
      const { page, size, ...params} = this.tempSelecForm
      if (this.multipleSelectList.length) {
        params.ids = this.multipleSelectList.join()
      }
      params.content = this.content
      params.stationId =  this.selectForm.stationId.join(',')

      params.downloadEntranceState = this.selectForm.downloadEntranceState;
      params.sendType = 2;

      this.$confirm(`请再次确认是否发送${this.studentNum}条短信？`, '提示', {
        type: 'warning'
      }).then(() => {
        return sentMessageFn(params)
      }).then(({ code }) => {
        if (code == 1) {
          this.$message.success('发送成功。')
          this.content = `{学生姓名}您好，`
          this.sendDialog = false
        }
      }).catch(() => {
      })
    },

    askPushFn() {
      if (!this.pagination.total) {
        return
      }
      if (!this.askContent) {
        this.$message.warning('请填写短信内容')
        return
      }
      const { page, size, ...params} = this.tempSelecForm
      if (this.multipleSelectList.length) {
        params.ids = this.multipleSelectList.join()
      }
      params.content = this.askContent
      params.stationId =  this.selectForm.stationId.join(',')

      params.downloadEntranceState = this.selectForm.downloadEntranceState;
      params.sendType = 5;

      this.$confirm(`请再次确认是否发送${this.studentNum}条短信？`, '提示', {
        type: 'warning'
      }).then(() => {
        return sentMessageFn(params)
      }).then(({ code }) => {
        if (code == 1) {
          this.$message.success('发送成功。')
          this.content = `{学生姓名}您好，您已成功报名{批次名称}考试，为方便给您进行排考安排，请点击{确认考试的链接}确认是否参加考试：`
          this.sendDialog = false
        }
      }).catch(() => {
      })
    },

    bachOper(res) {
      this.multipleSelectList = res.map((item) => {
        return item.planStudentId;
      });
    },
    changeSize(num) {
      this.selectForm.size = num;
      this.getTableList();
    },
    changePage(p) {
      this.selectForm.page = p;
      this.getTableList();
    },
  }
}
</script>

<style>
.mainCon {
  margin-top: 16px;
  padding: 24px;
  background: #fff;
  border-radius: 8px;
}
.export-setting{
  ul {
    margin-left: 5px;
    li {
      line-height: 26px;
    }
  }
}
</style>